<template>
  <div class="area-select" :class="isLineFeed ? 'area' : ''">
    <van-field :placeholder="placeholder" :label="label" :required="required" v-model="value" @click="() => {areaSelectShow = true;}" readonly></van-field>
    <van-popup v-model="areaSelectShow" position="bottom" ref="areaSelect">
      <van-area :area-list="areaData" @confirm="handleSelect" @cancel="() => {areaSelectShow = false;}" />
    </van-popup>
  </div>
</template>

<script>
import Constants from '@constants'
export default {
  name: 'AreaSelect',
  props: {
    placeholder: String,
    label: String,
    required: Boolean,
    isLineFeed: Boolean,
  },
  data () {
    return {
      value: '',
      areaSelectShow: false,
      areaData: Constants.AREA
    }
  },
  methods: {
    handleSelect (result) {
      const addressArr = result.map(item => {
        return item.name;
      });
      this.value = addressArr.join(' ');
      this.areaSelectShow = false;
      this.$emit('select', result);
    }
  }
}
</script>

<style lang="scss" scoped>
@import './AreaSelect.scss';
</style>